import React from 'react';
import cn from 'classnames';
import formStyles from '../../shared/form.module.scss';
import { FormStateSpecification } from '../formStateSpecification';

export interface IProps {
  /**
   * Indicates if the field has been touched (e.g., clicked into and out of)
   */
  touched?: boolean,
  /**
   * Indicates if the field content has changed since the last form submission
   */
  modifiedSinceLastSubmit?: boolean,
  /**
   * Error message to display for the field
   */
  error?: React.ReactNode,
  /**
   * Warning message to display for the field
   */
  warning?: React.ReactNode,
  /**
   * Error message to display globally for the form upon submission
   */
  submitError?: React.ReactNode,
  /**
   * Additional CSS class for custom styling
   */
  className?: string,
  dataTest?: string,
}

const FormError = ({
  touched = false,
  error = '',
  warning = '',
  submitError,
  modifiedSinceLastSubmit,
  className,
  dataTest = 'formError',
}: IProps) => {
  const meta = {
    touched,
    error,
    warning,
    submitError,
    modifiedSinceLastSubmit,
  } as const;

  if (FormStateSpecification.error(meta)) {
    return (
      <div className={ cn(formStyles.formError, className) } data-test={ dataTest }>
        <span>{ error || submitError }</span>
      </div>
    );
  }

  if (FormStateSpecification.warning(meta)) {
    return (
      <div className={ formStyles.formWarning } data-test={ dataTest }>
        <span>{ warning }</span>
      </div>
    );
  }

  return null;
};

export default FormError;
